import React, { useEffect, useState } from "react";
import { AppLayout } from "layout";
import { MyContentData } from "modules/MyContent/components";
import { ContentsService } from "services/ContentsService";
import { useAuth } from "context/authContext";
import { Content as ContentType } from "types/types";

type Props = {};

const MyContentContainer = (props: Props) => {
  const { currentUser } = useAuth();
  const [allContentsData, setAllContentsData] = useState<ContentType[]>([]);
  const [isloading, setIsLoading] = useState(true);

  // Map Firestore data to ContentType
  const mapToContentType = (data: any[]): ContentType[] => {
    return data.map((item) => ({
      id: item.id || "",
      createdBy: item.createdBy || null,
      type: item.type || "handout",
      isPublished: item.isPublished || false,
      category: item.category || "Psychotherapy",
      title: item.title || "",
      coverPhotoUrl: item.coverPhotoUrl || "",
      summary: item.summary || "",
      expectations: item.expectations || "",
      sourceOfKnowledge: item.sourceOfKnowledge || "Clinical Insights",
      price: item.price || 0,
      promotion: item.promotion || {
        isActive: false,
        discountPercent: 0,
        code: "",
      },
      purchaseCount: item.purchaseCount || 0,
      revenue: item.revenue || 0,
      currentStatus: item.currentStatus || {
        date: new Date(),
        status: "draft",
      },
      statusHistory: item.statusHistory || [],
      createdAt: item.createdAt || new Date(),
      updatedAt: item.updatedAt || new Date(),
      contentStructure: item.contentStructure || [],
    }));
  };

  const getHandOutData = async () => {
    setIsLoading(true);
    try {
      const uid = currentUser?.uid;
      if (!uid) return;

      // Fetch all handouts for the user
      const data = await ContentsService.getContentsAgainstByUserId(uid);

      if (data.length > 0) {
        // setAllContentsData(data);
        // Map the data to ContentType
        const mappedData = mapToContentType(data);

        setAllContentsData(mappedData);
      } else {
        setAllContentsData([]);
      }
    } catch (error) {
      console.error("Failed to fetch handout data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHandOutData();
  }, []);

  return (
    <AppLayout>
      <MyContentData
        allContentsData={allContentsData}
        setAllContentsData={setAllContentsData}
        isloading={isloading}
      />
    </AppLayout>
  );
};

export default MyContentContainer;
